import { usePageTitle } from '../../hooks/usePageTitle';
import PageLayout from '../../layouts/PageLayout';
import HeroSection from './components/HeroSection/HeroSection';
import MetricsSection from './components/MetricsSection/MetricsSection';
import DomainPreview from './components/DomainPreview';
import QuickNav from './components/QuickNav';
import EnhancedHeroSection from './components/HeroSection/EnhancedHeroSection';

export default function Home() {

  usePageTitle('Technical Innovation Architect');

  return (
    <PageLayout>
      <EnhancedHeroSection />
      <MetricsSection />
      <DomainPreview />
      <QuickNav />
    </PageLayout>
  );
}